import React, { useState } from 'react'
// import { CSVLink } from "react-csv";
// export default function CsvDownload({headers,data ,filename}) {
//   return (
//     <CSVLink filename={filename} className='export-btn' headers={headers} data={data}>Export Table</CSVLink>
//   )
// }
// download={usertype.csv}
export default function CsvDownloadAll(props) {
  const { href, onClick } = props;
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = async () => {
    if (isExporting) {
      return;
    }

    try {
      setIsExporting(true);
      await Promise.resolve(onClick());
    } finally {
      setIsExporting(false);
    }
  };

  if (onClick) {
    return (
      <button type="button" className="exportall-btn" onClick={handleClick} disabled={isExporting}>
        {isExporting ? "Exporting..." : "Export All"}
      </button>
    );
  }

  return (

            <a className="exportall-btn" href={href} >
        Export All
        </a>
  )
}




